import * as ng from 'angular';
import * as uir from '@uirouter/angularjs';

import { SessionService } from '../shared';

ng.module('e360').run(requiresAuthHook);

requiresAuthHook.$inject = ['$transitions', 'session'];
function requiresAuthHook($transitions:uir.TransitionService, session:SessionService) {
   // Register the "requires auth" hook with the TransitionsService
   $transitions.onBefore({to: requiresAuthCheck}, redirectToLogin, {priority: 100});

   // Matches all destination state's unless data has a truthy 'allowAnon' property
   function requiresAuthCheck(state:uir.StateObject) {
      // include login state in this hook so redirectToLogin() can refresh session
      // before login bypass hook (this hook has higher priority)
      if (state.data && state.data.allowAnon && state.name != 'login') {
         return false;
      }

      return true;
   }

   // Function that returns a redirect for the current transition to the login state
   // if the user is not currently authenticated, and initializes the user session
   // object on first load
   function redirectToLogin(transition:uir.Transition):any {
      let $state = transition.router.stateService;

      if (session.getUser() == null && session.getToken()) {
         return session.refreshUser();
      }

      // no need to redirect to login when already transitioning to it
      if (!session.isLoggedIn() && transition.to().name != 'login') {
         return $state.target('login', undefined, { location: false });
      }
   }
}
